import { render, staticRenderFns } from "./EmailCampaignTabs.vue?vue&type=template&id=78acb3ba&"
import script from "./EmailCampaignTabs.vue?vue&type=script&lang=ts&"
export * from "./EmailCampaignTabs.vue?vue&type=script&lang=ts&"
import style0 from "./EmailCampaignTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabs,QRouteTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QTabs,QRouteTab,QTabPanels,QTabPanel}, component.options.components || {})
